<template>
  <div id="app">
    <div class="main">
      <div class="sider">
        <router-link to="/" class="logo">
          <img src="./assets/images/logo.png">
        </router-link>
        <!-- <Menu @on-select="menuChange" :theme="theme" :active-name="activeName" :open-names="[openName]" accordion>
          <template v-for="(item,index) in menu" v-if="item.role >= userInfo.role_id && item.noRole != userInfo.role_id">
            <Submenu :key="index" v-if="item.children" :name="item.name" :to="item.name">
              <template slot="title">
                <Icon :type="item.icon" size="20" />
                {{ item.title }}
              </template>
              <MenuItem v-for="(subItem, subIndex) in item.children" v-if="userInfo.role_id <= subItem.role" :key="subIndex"
                        :name="subItem.name" :to="subItem.name">{{ subItem.title }}
              </MenuItem>
            </Submenu>
            <MenuItem :key="index" v-else :name="item.name" :to="item.name">
              <Icon :key="index" :type="item.icon" size="20" /> {{ item.title }}
            </MenuItem>
          </template>
        </Menu> -->
        <Menu :theme="theme" :active-name="activeName" :open-names="[openName]" accordion>
          <template v-for="(item,index) in menu">
            <Submenu :key="item.title" v-if="item.children" :name="item.title" :to="item.name">
              <template slot="title">
                <Icon :type="item.icon" size="20" />
                {{ item.title }}
              </template>
              <MenuItem v-for="(subItem) in item.children" :key="subItem.title"
                        :name="subItem.name" :to="subItem.name">{{ subItem.title }}
              </MenuItem>
            </Submenu>
            <MenuItem :key="index" v-else :name="item.name" :to="item.name">
              <Icon :key="index" :type="item.icon" size="20" /> {{ item.title }}
            </MenuItem>
          </template>
        </Menu>
        <!-- <div class="menu-tip">技术支持 <a href="mailto:service@hiliad.com">service@hiliad.com</a></div> -->
      </div>
      <div class="content">
        <div class="header">
          <div class="header-nav">
            <a target="_blank" href="http://developer.extscreen.com/">快应用文档中心</a>
          </div>
          <div class="header-user text-right">
            <Poptip placement="bottom-end" width="250" v-model="userInfoFlag">
              <span>{{userInfo.username}}</span>
              <Icon type="ios-contact" size="30" />
              <div class="header-user-info" slot="content">
                <div class="user-info-title">
                  <span>账号信息</span>
                  <!--<p><Icon type="md-alert" /> 未认证</p>-->
                </div>
                <div class="user-info-con">
                  <p>账号：{{userInfo.username}}</p>
                  <p>手机号：{{userInfo.mobile}}</p>
                  <!-- <p>审核状态：<span :class="userInfo.author">{{userInfo.authorName}}</span></p> -->
                </div>
                <div class="wx-qrcode-box">
                  <img class="" v-show="refCodeLoading" :src="wxQrcode" />
                </div>
                <Button class="ref-wx-ercode" type="primary" @click="refWxQrcode">重新生成</Button>
                <div class="user-info-btn">
                  <a @click="editPwd">修改密码</a>
                  <a @click="logout">退出登录</a>
                </div>
              </div>
            </Poptip>
          </div>
        </div>
        <div class="router-view">
          <router-view/>
        </div>
      </div>
    </div>
    <Modal :mask-closable="false"
           v-model="editPwdFlag"
           title="修改密码"
           @on-cancel="pwdCancel"
           :loading="loading"
           @on-ok="postPwd">
      <Form ref="pwdValidate" :model="pwdValidate" :rules="ruleValidatePwd" :label-width="80">
        <FormItem label="旧密码" prop="password">
          <Input class="login-input" type="password" maxlength="20" v-model="pwdValidate.password" placeholder="请输入旧密码" />
        </FormItem>
        <FormItem label="新密码" prop="password2">
          <Input class="login-input" type="password" maxlength="20" v-model="pwdValidate.password2" placeholder="请输入新密码,可包含字母数字" />
        </FormItem>
        <FormItem label="确认密码" prop="newPassword">
          <Input class="login-input" type="password" maxlength="20" v-model="pwdValidate.newPassword" placeholder="请再次输入新密码" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import https from './https'
export default {
  name: 'developer',
  data () {
    return {
      loading: true,
      loginFlag: true,
      userInfoFlag: false,
      editPwdFlag: false,
      countdownNum: 60,
      refCodeLoading: true,
      userInfo: {
        username: '',
        mobile: '',
        role_id: 3,
        id: ''
      },
      wxQrcode: '',
      userId: '',
      openName: '',
      activeName: 'app',
      pwdValidate: {
        password: '',
        password2: '',
        newPassword: ''
      },
      ruleValidatePwd: {
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请输入新密码,可包含字母数字', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: '不符合规范，请重新输入', trigger: 'blur' },
          { type: 'string', min: 6, message: '不符合规范，请重新输入', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' }
        ]
      },
      theme: 'dark',
      menu: [
        {
          title: '快应用应用管理',
          name: 'esApp',
          icon: 'ios-desktop',
          role: 3,
          noRole: 0
        },
        {
          title: '卡片管理',
          name: 'esCard',
          icon: 'ios-desktop',
          role: 3,
          noRole: 0
        },
        {
          title: 'SDK插件管理',
          name: 'esSdk',
          icon: 'ios-desktop',
          role: 3,
          noRole: 0
        },
        {
          title: 'APK插件管理',
          name: 'esApk',
          icon: 'ios-desktop',
          role: 3,
          noRole: 0
        },
        {
          title: '资质认证',
          name: 'certification',
          icon: 'ios-medal',
          role: 3,
          noRole: 1
        },
        // {
        //   title: '手机发起端管理',
        //   name: 'mobileApp',
        //   icon: 'md-phone-portrait',
        //   role: 3
        // },
        // {
        //   title: '数据统计',
        //   name: 'report',
        //   icon: 'ios-stats',
        //   role: 3,
        //   noRole: 0
        // },
        {
          title: '审核管理',
          name: 'check',
          icon: 'ios-paper',
          role: 2,
          noRole: 0,
          children: [
            {
              title: '应用审核',
              name: 'checkApp',
              role: 2
            },
            {
              title: '版本审核',
              name: 'checkVersion',
              role: 2
            },
            {
              title: '企业资质审核',
              name: 'checkCertification',
              role: 1
            },
            {
              title: '开发者资质审核',
              name: 'checkIndividual',
              role: 1
            },
            {
              title: '支付审核',
              name: 'checkPay',
              role: 1
            },
            {
              title: '插件审核',
              name: 'checkSdk',
              role: 2
            },
            {
              title: '插件版本审核',
              name: 'checkApk',
              role: 2
            }
          ]
        },
        {
          title: '用户权限管理',
          name: 'users',
          icon: 'ios-people',
          role: 1,
          noRole: 0
        },
        {
          title: '测试用户权限管理',
          name: 'testUsers',
          icon: 'ios-people',
          role: 1,
          noRole: 0
        },
        {
          title: '渠道管理',
          name: 'channelManage',
          icon: 'ios-people',
          role: 1,
          noRole: 0
        },
        {
          title: '测试应用管理',
          name: 'testMac',
          icon: 'ios-people',
          role: 3,
          noRole: 1
        },
        {
          title: '测试插件管理',
          name: 'testMacSdk',
          icon: 'ios-people',
          role: 3,
          noRole: 1
        },
        // {
        //   title: '数据中心',
        //   name: 'dataCenter',
        //   icon: 'ios-people',
        //   role: 3,
        //   noRole: 0
        // },
        // {
        //   title: '订单明细',
        //   name: 'payDetails',
        //   icon: 'ios-people',
        //   role: 3,
        //   noRole: 0
        // },
        // {
        //   title: '结算中心',
        //   name: 'bills',
        //   icon: 'ios-people',
        //   role: 3,
        //   noRole: 0
        // },
        {
          title: '上架商店',
          name: 'shelfShop',
          icon: 'ios-people',
          role: 3,
          noRole: 1
        }
      ]
    }
  },
  created () {
    if (!https.token) this.loginFlag = false
    let meta = this.$route.meta
    if (meta.parent) {
      this.openName = meta.parent[0].name
      this.activeName = meta.name
    } else {
      this.openName = ''
      this.activeName = meta.name
    }
    // 渲染网站标题
    let title = this.$route.meta.title
    let parentTitle = ''
    if (this.$route.meta.parent) {
      let parent = this.$route.meta.parent
      parent.forEach(n => {
        parentTitle += n.title + ' - '
      })
    }
    document.title = 'HLTECH · ES 快应用 - ' + parentTitle + title
    this.userInfo.username = window.localStorage.getItem('userName')
    this.userInfo.id = window.localStorage.getItem('userId')
    this.userInfo.role_id = window.localStorage.getItem('role_id')
    // this.token = window.localStorage.getItem('token')
    console.log('userInfo', this.userInfo)
    https.request({
      method: 'post',
      url: 'account',
      headers: {
        'Content-Type': 'application/json',
        'satoken': https.token
      }
    }).then(res => {
      this.userInfo = res.data
      window.localStorage.setItem('userId', res.data.id)
      this.getPermission()
      switch (res.data.aduit_stats) {
        case 2:
          this.userInfo.authorName = '已认证'
          this.userInfo.author = 'authorized'
          break
        case 0:
          this.userInfo.authorName = '未认证'
          this.userInfo.author = 'unauthorized'
          break
        case 1:
          this.userInfo.authorName = '审核中'
          this.userInfo.author = 'need_check'
          break
        case 3:
          this.userInfo.authorName = '未通过'
          this.userInfo.author = 'check_false'
          break
        default:
          this.userInfo.author = 'unauthorized'
          this.userInfo.authorName = '未认证'
          break
      }
    }).catch(error => {
      this.$Message.error(error)
    })
    this.getWxCode()
  },
  methods: {
    getPermission () {
      https.request({
        method: 'get',
        url: 'permission',
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        }
      }).then(res => {
        console.log(res)
        let arr = []
        res.data.map(item => {
          if (item.children) {
            let sonArr = []
            item.children.map(sItem => {
              sonArr.push({
                title: sItem.name,
                name: sItem.route.substring(11, sItem.route.length)
              })
            })
            if (item.showType === 1) {
              arr.push({
                title: item.name,
                name: 'check',
                icon: 'ios-desktop',
                children: [...sonArr]
              })
            }
          } else {
            if (item.showType === 1) {
              arr.push({
                title: item.name,
                name: item.route.substring(11, item.route.length),
                icon: 'ios-desktop'
              })
            }
          }
        })
        this.menu = [...arr]
      })
    },
    validPwd (value, value2) {
      if (value === value2) {
        return true
      } else {
        this.$Message.error('新密码两次输入不一致，请再次输入')
        return false
      }
    },
    editPwd () {
      this.editPwdFlag = true
      this.userInfoFlag = false
    },
    refWxQrcode () {
      this.getWxCode(true)
    },
    getWxCode (ref = false) {
      this.refCodeLoading = false
      https.request({
        method: 'get',
        url: '/v1/miniprogram/qrcode',
        params: {
          refresh: ref
        }
      }).then(res => {
        this.refCodeLoading = true
        this.wxQrcode = `data:image/png;base64,${res.data}`
      })
    },
    menuChange (val) {
      if (val === 'shelfShop') {
        // location.reload()
        // this.$router.go(0)
        // this.$router.push('esApp')
        // this.$router.push('shelfShop')
      }
    },
    pwdCancel () {
      this.$refs['pwdValidate'].resetFields()
    },
    postPwd () {
      this.$refs['pwdValidate'].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            if (this.validPwd(this.pwdValidate.password2, this.pwdValidate.newPassword)) {
              https.request({
                method: 'post',
                url: 'changePassword',
                headers: {
                  'Content-Type': 'application/json',
                  'satoken': https.token
                },
                data: {
                  newPassword: this.pwdValidate.newPassword,
                  password: this.pwdValidate.password
                }
              }).then(res => {
                console.log(res)
                if (res.code === 500) {
                  this.$Message.error(res.msg)
                  return
                }
                this.$Message.success('修改成功')
                this.editPwdFlag = false
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    logout () {
      https.request({
        method: 'post',
        url: '/logout',
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        }
      }).then(res => {
        window.localStorage.removeItem('userName')
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userId')
        window.localStorage.removeItem('role_id')
        this.userInfoFlag = false
        this.$Message.success({
          content: '退出登录成功',
          onClose: () => {
            this.$router.push('/')
            location.reload()
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      let meta = this.$route.meta
      console.log('-=-=-=-=-=', meta)
      if (meta.parent) {
        this.openName = meta.parent[0].name
        this.activeName = meta.name
      } else {
        this.openName = ''
        this.activeName = meta.name
      }
      let title = to.meta.title
      let parentTitle = ''
      if (to.meta.parent) {
        let parent = to.meta.parent
        parent.forEach(n => {
          parentTitle += n.title + ' - '
        })
      }
      document.title = 'HLTECH · ES 快应用 - ' + parentTitle + title
    }
  }
}
</script>

<style lang="scss">
  @import "assets/val";
  @import "assets/global";
  html, body, #app {
    height: 100%;
  }
  .logo {
    background-color: rgb(67, 67, 67);
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    color: #fff;
    img {
      height: 45px;
      vertical-align: middle;
    }
    strong, p {
      display: block;
      width: 100%;
      text-align: center;
      font-size: 20px;
    }
    p {
      font-size: 16px;
    }
  }
  .header {
    background: rgb(67, 67, 67);
    color: #fff;
    height: 70px;
    line-height: 50px;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    .header-nav a {
      padding: 0 20px;
      font-size: 16px;
      color: rgba(255,255,255,.7);
      &:hover {
        color: #fff;
      }
    }
    .header-user {
      a {
        color: #fff;
        font-size: 14px;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
      i {
        vertical-align: middle;
      }
      .ivu-poptip-rel {
        padding-right: 8px;
      }
      .ivu-poptip-body {
        padding: 0;
        .ivu-poptip-body-content {
          overflow: hidden;
        }
      }
    }
    .header-user-info {
      color: #000;
      text-align: left;
      .user-info-title {
        padding: 0 15px;
        line-height: 40px;
        font-weight: bold;
        border-bottom: 1px $border solid;
      }
      .user-info-con {
        padding: 15px;
        .authorized {
          color: $success;
        }
        .unauthorized {
          color: $warning;
        }
        .need_check {
          color: $warning;
        }
        .check_false {
          color: $error;
        }
      }
      .wx-qrcode-box{
        display: flex;
        padding: 15px;
        img{
          width:100px;
          height:100px;
        }
      }
      .ref-wx-ercode{
        margin-left:15px;
        margin-bottom:15px;
      }
      .user-info-btn {
        border-top: 1px $border solid;
        height: 40px;
        display: flex;
        justify-content: center;
        a {
          line-height: 40px;
          border-left: 1px $border solid;
          width: 50%;
          color: $primary;
          text-align: center;
          &:first-child {
            border-left: 0;
          }
        }
      }
    }
  }
  .main {
    display: flex;
    height: 100%;
    box-sizing: border-box;
    .sider {
      height: 100%;
      width: 240px;
      position: relative;
      & > .ivu-menu {
        padding-top: 16px;
        background-color: rgb(102, 102, 102);
      }
      .menu-tip {
        width: 100%;
        position: absolute;
        bottom: 20px;
        text-align: center;
        color: #fff;
        z-index: 1000;
        a {
          color: #fff;
        }
      }
    }
    .content {
      width: calc(100% - 240px);
    }
    .router-view {
      overflow: auto;
      height: calc(100% - 70px);
    }
    .ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
      background-color: rgb(102, 102, 102) !important;
    }
    .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
      background: rgb(67, 67, 67) !important;
    }
    .ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu),
    .ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):hover {
      background: rgb(67, 67, 67)!important;
      color: #fff!important;
    }
    .ivu-menu {
      overflow: auto;
      height: calc(100% - 70px);
      background: rgb(67, 67, 67);
    }
  }
</style>



// WEBPACK FOOTER //
// src/developer.vue